import styled from 'styled-components';
import { FunctionColor } from '@lux/tokens';

export const WrapperSection = styled.section`
    width: max-content;
    background-color: ${FunctionColor.function0};
    line-height: 18px;
    min-height: 0;
    padding: 3px 8px 3px 8px;
    margin-top: 0;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    flex-direction: row;
    color: ${FunctionColor.function100};

    > svg {
        margin: 0 4px 0 0;
    }
`;
